export const isInvitationURL = () => {
  return (
    window.location.pathname.includes("invitation") ||
    window.location.pathname.includes("qr-recogida")
  );
};

export const getInvitationId = () => {
  if (isInvitationURL()) {
    const url = window.location.pathname;
    const parts = url.split("/");
    if (parts.length > 2 && parts[2]) {
      return parts[2]; // The InvitationId
    }
    return null;
  }
  return null;
};

export const isDownloadURL = () => {
  return window.location.pathname.includes("download");
};

export const setDownloadURL = () => {
  window.location.replace("/download");
};

export const setHomeURL = () => {
  window.location.replace("/");
};
